import { collection, getDocs } from 'firebase/firestore';
import { firestore } from 'services/firebase/client';
import { BeerPack } from 'utils/types/BeerPack';

export const fetchBeerPacks = async (): Promise<BeerPack[]> => {
  try {
    const querySnapshot = await getDocs(collection(firestore, 'beer_packs'));
    return querySnapshot.docs.map(doc => {
      const data = doc.data();

      return {
        id: doc.id, // ID do documento Firestore (string)
        label: data.label,
        subtitle: data.subtitle,
        description: data.description,
        image: data.image,
        price: data.price,
        priceWithCup: data.priceWithCup,
        priceWithoutCup: data.priceWithoutCup,
        stock: data.stock,
      } as BeerPack;
    });
  } catch (error) {
    console.error('Erro ao buscar os packs:', error);
    return [];
  }
};

/**
 * Packs da série Hop Head (IPAs). Coleção `beer_packs_hop_head`.
 * Se estiver vazia, reutiliza os packs gerais até a coleção ser preenchida.
 */
export const fetchHopHeadBeerPacks = async (): Promise<BeerPack[]> => {
  try {
    const querySnapshot = await getDocs(
      collection(firestore, 'beer_packs_hop_head'),
    );
    const packs = querySnapshot.docs.map(docSnap => {
      const data = docSnap.data();
      return {
        id: docSnap.id,
        label: data.label,
        subtitle: data.subtitle,
        description: data.description,
        image: data.image,
        price: data.price,
        priceWithCup: data.priceWithCup,
        priceWithoutCup: data.priceWithoutCup,
        stock: data.stock,
      } as BeerPack;
    });
    if (packs.length > 0) {
      return packs;
    }
  } catch (error) {
    console.error('Erro ao buscar packs Hop Head:', error);
  }
  return fetchBeerPacks();
};
